import { ChevronRight, LucideIcon } from "lucide-react";
import { ToggleSwitch } from "./toggle-switch";

interface SettingsItemProps {
  icon: LucideIcon;
  label: string;
  subtitle: string;
  action: () => void;
  toggle?: boolean;
  value?: boolean;
  showBorder?: boolean;
  disabled?: boolean;
  variant?: "default" | "destructive";
}

export function SettingsItem({
  icon: Icon,
  label,
  subtitle,
  action,
  toggle = false,
  value = false,
  showBorder = false,
  disabled = false,
  variant = "default",
}: SettingsItemProps) {
  const destructive = variant === "destructive";
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => {
        if (!disabled) action();
      }}
      className={`w-full px-4 py-4 flex items-center gap-4 transition-colors ${
        showBorder ? "border-b border-border" : ""
      } ${disabled ? "opacity-55 cursor-not-allowed" : "hover:bg-accent"}`}
    >
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
          destructive ? "bg-destructive/10" : "bg-primary/10"
        }`}
      >
        <Icon className={`w-5 h-5 ${destructive ? "text-destructive" : "text-primary"}`} />
      </div>
      <div className="flex-1 text-left">
        <div className={`font-medium ${destructive ? "text-destructive" : "text-foreground"}`}>{label}</div>
        <div className={`text-sm ${destructive ? "text-muted-foreground" : "text-primary"}`}>{subtitle}</div>
      </div>
      {toggle ? (
        <ToggleSwitch enabled={value} disabled={disabled} />
      ) : (
        <ChevronRight
          className={`w-5 h-5 shrink-0 ${destructive ? "text-destructive/60" : "text-muted-foreground"}`}
        />
      )}
    </button>
  );
}